import React, { useState } from "react";
import { sendToPanelDeliverApi } from "../../../../Api/PanelAdminServices";
import Button from "../../../Button/Button";
import Style from "./SupplierInfo.module.scss";
const SupplierInfo = ({ handleOk, Info }) => {
  const [disable, setDisable] = useState(false);

  const goToPanel = () => {
    setDisable(true);
    const info = {
      user_id: Info.id,
      user_type: 'supplier',
    };
    sendToPanelDeliverApi(info, (res) => {
      setDisable(false);
      window.open(
        // `https://supplier.barest.ir/login_as/index.php?type=${Info.typeUrl}&token=${res.token}`
        `https://supplier.barest.ir/login_as/index.php?type=${Info.type}&token=${res.token}`
      );
    });
  };
  let text=[]
  Info.about_us&&Info.about_us.split("&amp;amp;quot;").map((item,index)=>{
    return (
      <div key={index}>{
        text=text+item
      }</div>
    )
  })
  let finalText=String(text).replace('n','')

  return (
    <div className={Style.componentHolder}>
      <div className={Style.infoHolder}>
        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleName}>نام</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.name}>
              {Info.first_name + " " + Info.last_name}
            </p>
          </div>
        </div>
        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleEmail}>ایمیل</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.email}>
              {Info.email ? Info.email : " !ایمیل وجود ندارد"}
            </p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titlePhone}>شماره تماس</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.phone}>{Info.phone}</p>
          </div>
        </div>
        {Info.phone_2&&<div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titlePhone}>2شماره تماس</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.phone}>{Info.phone_2}</p>
          </div>
        </div>}
       { Info.phone_3&&<div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titlePhone}>3شماره تماس</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.phone}>{Info.phone_3}</p>
          </div>
        </div>}

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleAddress}>شهر</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.address}>{Info.city_name}</p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleAddress}>تلفن ثابت</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.address}>
              {Info.telephone ? Info.telephone : "شماره تماس وجود ندارد"}
            </p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleAddress}>نام رستوران</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.address}>{Info.name}</p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleAddress}>نوع</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.address}>{Info.type}</p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleAddress}>درباره ما</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.address}>
              {finalText}
              {/* {Info.about_us.split("n").map((item, index) => {
                return (
                  <div key={index}>
                    {item}
                    <br />
                  </div>
                );
              })} */}
              {/* {Info.about_us ? Info.about_us : "!درباره ما وجود ندارد"} */}
            </p>
          </div>
        </div>

        <div className={Style.row}>
          <div className={Style.titleHolder}>
            <p className={Style.titleAddress}>آدرس</p>
          </div>
          <div className={Style.contentHolder}>
            <p className={Style.address}>{Info.address}</p>
          </div>
        </div>
      </div>
      <div className={Style.btnHolder}>
        <Button
          Value={"وارد شدن به پنل تامین کننده"}
          ClickHandler={goToPanel}
          ClassBtn={"okBtn"}
          disabledprops={disable}
        />
        <Button Value={"تایید"} ClickHandler={handleOk} ClassBtn={"okBtn"} />
      </div>
    </div>
  );
};

export default SupplierInfo;
